import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Ticket } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { getPlacesByCategory } from '../data/places';
export function FestivalsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const festivals = getPlacesByCategory('Festivals');
  return <div className="min-h-screen bg-white" data-id="element-1066">
      {/* Hero */}
      <div className="border-b border-gray-100" data-id="element-1067">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-24" data-id="element-1068">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-1069">
            <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full mb-6" data-id="element-1070">
              <Calendar className="w-4 h-4 text-gray-600" strokeWidth={2} data-id="element-1071" />
              <span className="text-sm font-semibold text-gray-700 uppercase tracking-wider" data-id="element-1072">
                Annual Events
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight tracking-tight" data-id="element-1073">
              Festivals & Events
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1074">
              Experience Nairobi's vibrant festival scene from music
              celebrations to culinary experiences, fashion shows to cultural
              gatherings.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-1075">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1076">
          {festivals.map((festival, index) => <motion.div key={festival.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-1077">
              <Link to={`/place/${festival.id}`} className="block group" data-id="element-1078">
                <div className="border-2 border-gray-100 hover:border-gray-300 transition-all overflow-hidden h-full flex flex-col" data-id="element-1079">
                  {/* Image */}
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-1080">
                    <img src={festival.image} alt={festival.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1081" />
                    <div className="absolute top-4 left-4" data-id="element-1082">
                      <span className="px-3 py-1 bg-white text-gray-900 text-xs font-bold uppercase" data-id="element-1083">
                        {festival.category}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6 flex-1 flex flex-col" data-id="element-1084">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:underline" data-id="element-1085">
                      {festival.name}
                    </h3>

                    <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1" data-id="element-1086">
                      {festival.description}
                    </p>

                    <div className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-1087">
                      <div className="flex items-center gap-2" data-id="element-1088">
                        <MapPin className="w-4 h-4" strokeWidth={2} data-id="element-1089" />
                        <span data-id="element-1090">{festival.location}</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-1091">
                        <Ticket className="w-4 h-4" strokeWidth={2} data-id="element-1092" />
                        <span data-id="element-1093">{festival.info.entryFee}</span>
                      </div>
                    </div>

                    <div className="pt-4 border-t border-gray-100" data-id="element-1094">
                      <span className="text-sm font-semibold text-gray-900 group-hover:underline" data-id="element-1095">
                        Learn more →
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>

      <ScrollToTop data-id="element-1096" />
      <Footer data-id="element-1097" />
    </div>;
}